module.exports = __webpack_public_path__ + "img/Gallery_1_05.47e271bd.jpeg";